import type { EmbarcacaoDetailSection } from "../embarcacao-detail-section";
import { BaseTecnicaSection, BASE_TECNICA_ID, BASE_TECNICA_TITLE } from "./base-tecnica-section";
import { ClasseSection, CLASSE_ID, CLASSE_TITLE } from "./classe-section";
import { ComercialSection, COMERCIAL_ID, COMERCIAL_TITLE } from "./comercial-section";
import {
  DimensoesPrincipaisSection,
  DIMENSOES_PRINCIPAIS_ID,
  DIMENSOES_PRINCIPAIS_TITLE,
} from "./dimensoes-principais-section";
import { TanquesSection, TANQUES_ID, TANQUES_TITLE } from "./tanques-section";
import {
  ConsumoOperacaoSection,
  CONSUMO_OPERACAO_ID,
  CONSUMO_OPERACAO_TITLE,
} from "./consumo-operacao-section";
import { VazaoBombasSection, VAZAO_BOMBAS_ID, VAZAO_BOMBAS_TITLE } from "./vazao-bombas-section";
import { SistemasDpSection, SISTEMAS_DP_ID, SISTEMAS_DP_TITLE } from "./sistemas-dp-section";
import { AcomodacoesSection, ACOMODACOES_ID, ACOMODACOES_TITLE } from "./acomodacoes-section";
import { MotoresSection, MOTORES_ID, MOTORES_TITLE } from "./motores-section";

export const EMBARCACAO_DETAIL_SECTIONS: EmbarcacaoDetailSection[] = [
  { id: BASE_TECNICA_ID, title: BASE_TECNICA_TITLE, Component: BaseTecnicaSection },
  { id: CLASSE_ID, title: CLASSE_TITLE, Component: ClasseSection },
  { id: COMERCIAL_ID, title: COMERCIAL_TITLE, Component: ComercialSection },
  {
    id: DIMENSOES_PRINCIPAIS_ID,
    title: DIMENSOES_PRINCIPAIS_TITLE,
    Component: DimensoesPrincipaisSection,
  },
  { id: SISTEMAS_DP_ID, title: SISTEMAS_DP_TITLE, Component: SistemasDpSection },
  { id: MOTORES_ID, title: MOTORES_TITLE, Component: MotoresSection },
  { id: CONSUMO_OPERACAO_ID, title: CONSUMO_OPERACAO_TITLE, Component: ConsumoOperacaoSection },
  { id: TANQUES_ID, title: TANQUES_TITLE, Component: TanquesSection },
  { id: VAZAO_BOMBAS_ID, title: VAZAO_BOMBAS_TITLE, Component: VazaoBombasSection },
  { id: ACOMODACOES_ID, title: ACOMODACOES_TITLE, Component: AcomodacoesSection },
];

export {
  BaseTecnicaSection,
  BASE_TECNICA_FIELDS,
  BASE_TECNICA_ID,
  BASE_TECNICA_LOADING_MESSAGE,
  BASE_TECNICA_TITLE,
} from "./base-tecnica-section";
export {
  ClasseSection,
  CLASSE_FIELDS,
  CLASSE_ID,
  CLASSE_LOADING_MESSAGE,
  CLASSE_TITLE,
} from "./classe-section";
export {
  ComercialSection,
  COMERCIAL_FIELDS,
  COMERCIAL_ID,
  COMERCIAL_LOADING_MESSAGE,
  COMERCIAL_TITLE,
} from "./comercial-section";
export {
  DimensoesPrincipaisSection,
  DIMENSOES_PRINCIPAIS_FIELDS,
  DIMENSOES_PRINCIPAIS_ID,
  DIMENSOES_PRINCIPAIS_LOADING_MESSAGE,
  DIMENSOES_PRINCIPAIS_TITLE,
} from "./dimensoes-principais-section";
export {
  TanquesSection,
  TANQUES_FIELDS,
  TANQUES_ID,
  TANQUES_LOADING_MESSAGE,
  TANQUES_TITLE,
} from "./tanques-section";
export {
  ConsumoOperacaoSection,
  CONSUMO_OPERACAO_FIELDS,
  CONSUMO_OPERACAO_ID,
  CONSUMO_OPERACAO_LOADING_MESSAGE,
  CONSUMO_OPERACAO_TITLE,
  CONSUMO_UNIT,
} from "./consumo-operacao-section";
export {
  VazaoBombasSection,
  VAZAO_BOMBAS_FIELDS,
  VAZAO_BOMBAS_ID,
  VAZAO_BOMBAS_LOADING_MESSAGE,
  VAZAO_BOMBAS_TITLE,
} from "./vazao-bombas-section";
export {
  SistemasDpSection,
  SISTEMAS_DP_FIELDS,
  SISTEMAS_DP_ID,
  SISTEMAS_DP_LOADING_MESSAGE,
  SISTEMAS_DP_TITLE,
} from "./sistemas-dp-section";
export {
  AcomodacoesSection,
  ACOMODACOES_COLUMNS,
  ACOMODACOES_FIELDS,
  ACOMODACOES_ID,
  ACOMODACOES_LOADING_MESSAGE,
  ACOMODACOES_TITLE,
} from "./acomodacoes-section";
export {
  MotoresSection,
  MOTORES_FIELDS,
  MOTORES_ID,
  MOTORES_LOADING_MESSAGE,
  MOTORES_TITLE,
  MOTOR_FALLBACK_LABEL,
} from "./motores-section";
